import { TextHoverColor } from "../../../../base/styles";
import clsx from "clsx";

export const SelectTextHoverColor = ({ title, value, className, onChange }:{
    title: string,
    value?: TextHoverColor,
    className?: string,
    onChange: (value?: TextHoverColor) => void,
}) => {
    const handleOnSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value as TextHoverColor;
        newValue ? onChange(newValue) : onChange(undefined);
    }

    return (
        <div className={clsx(className, "field-group mb-2")}>
            <label className="fs-8 fw-bold text-gray-600">{title}</label>
            <select
                onChange={handleOnSelectionChange}
                value={value || ""}
                className="form-select form-select-sm form-control-xs">
                <option></option>
                <option value={TextHoverColor.Primary}>Primary</option>
                <option value={TextHoverColor.Secondary}>Secondary</option>
                <option value={TextHoverColor.Success}>Success</option>
                <option value={TextHoverColor.Danger}>Danger</option>
                <option value={TextHoverColor.Warning}>Warning</option>
                <option value={TextHoverColor.Info}>Info</option>
                <option value={TextHoverColor.Light}>Light</option>
                <option value={TextHoverColor.Dark}>Dark</option>
                <option value={TextHoverColor.White}>White</option>

                <option value={TextHoverColor.InversePrimary}>Inverse Primary</option>
                <option value={TextHoverColor.InverseSecondary}>Inverse Secondary</option>
                <option value={TextHoverColor.InverseSuccess}>Inverse Success</option>
                <option value={TextHoverColor.InverseInfo}>Inverse Info</option>
                <option value={TextHoverColor.InverseLight}>Inverse Light</option>
                <option value={TextHoverColor.InverseWarning}>Inverse Warning</option>
                <option value={TextHoverColor.InverseDanger}>Inverse Danger</option>
                <option value={TextHoverColor.InverseDark}>Inverse Dark</option>
                <option value={TextHoverColor.InverseWhite}>Inverse White</option>
            </select>
        </div>
    )
}